import { Container } from "../components/Container";
import { PaywallSelectionForm } from "./PaywallSelectionForm";
import { PaywallPriceSelectionForm } from "./PaywallPriceSelectionForm";
import { useUpsellTabContext } from "../../UpsellTabContext";

export const AddonForm = () => {
  const { offerType } = useUpsellTabContext();

  if (offerType !== "addon") {
    return null;
  }

  return (
    <Container>
      <PaywallSelectionForm />
      <PaywallPriceSelectionForm />
    </Container>
  );
};
